import React from "react";
import { FaPalette, FaDesktop, FaServer, FaPenNib, FaCode, FaShareAlt, FaTags, FaBuilding, FaEnvelope, FaPaperPlane, FaIdCard, FaThumbsUp, FaImage, FaStickerMule, FaPrint, FaVectorSquare, FaYoutube, FaVideo } from "react-icons/fa";
import fullservices from "./FullServices";
import bgimage from '../../Assets/bgimage.PNG'

const icons = [
  <FaPalette />,
  <FaDesktop />,
  <FaServer />,
  <FaPenNib />,
  <FaCode />,
  <FaShareAlt />,
  <FaTags />,
  <FaBuilding />,
  <FaEnvelope />,
  <FaPaperPlane />,
  <FaIdCard />,
  <FaThumbsUp />,
  <FaImage />,
  <FaStickerMule />,
  <FaPrint />,
  <FaVectorSquare />,
  <FaYoutube />,
  <FaVideo />,
];

const ServicesPage = () => {

        const backgroundStyle = {
            backgroundImage: `url(${bgimage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            height: '40vh'
        };

  return (
    <div className="py-10">
                <div style={backgroundStyle}>
                <h1 className='bheading text-5xl pt-40 md:text-6xl lg:text-6xl font-semibold text-center text-white'>Our Services</h1>
            </div>
      <div className="container mx-auto p-4">
        <div className="grid md:grid-cols-2 gap-12 text-center">
          {fullservices.map((service, index) => (
            <div key={service.id} className="relative flex flex-col items-center">
              {/* Icon as background */}
              <div className="absolute text-8xl font-bold text-gray-300 z-10 top-1/2 transform -translate-y-[5vh]">
                {icons[index]}
              </div>
              {/* Title */}
              <h2 className="text-xl z-20 font-bold text-[#124E66] mt-4">
                {service.title}
              </h2>
              {/* Description */}
              <p className="text-gray-600 z-20 mt-2">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServicesPage;
